
import React from 'react';

interface CardProps {
    children: React.ReactNode;
    className?: string;
    id?: string;
    style?: React.CSSProperties;
}

const Card: React.FC<CardProps> = ({ children, className = '', id, style }) => {
    return (
        <div id={id} className={`bg-white rounded-lg shadow-lg overflow-hidden transition-shadow hover:shadow-xl ${className}`} style={style}>
            {children}
        </div>
    );
};

export const CardContent: React.FC<CardProps> = ({ children, className = '', id, style }) => {
    return <div className={`p-6 ${className}`} id={id} style={style}>{children}</div>;
};

export const CardHeader: React.FC<CardProps> = ({ children, className = '', id, style }) => {
    return <div className={`p-6 border-b border-stone-200 ${className}`} id={id} style={style}>{children}</div>;
};

export const CardTitle: React.FC<CardProps> = ({ children, className = '', id, style }) => {
    return <h3 className={`text-xl font-bold text-stone-800 ${className}`} id={id} style={style}>{children}</h3>;
};

export const CardDescription: React.FC<CardProps> = ({ children, className = '', id, style }) => {
    return <p className={`mt-1 text-stone-600 ${className}`} id={id} style={style}>{children}</p>;
};


export default Card;